import { render, staticRenderFns } from "./calendar-event.vue?vue&type=template&id=0903f600&"
import script from "./calendar-event.vue?vue&type=script&lang=js&"
export * from "./calendar-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports